import { render } from "./GroupsView.vue?vue&type=template&id=6f86f44a&scoped=true&ts=true"
import script from "./GroupsView.vue?vue&type=script&lang=ts"
export * from "./GroupsView.vue?vue&type=script&lang=ts"

import "./GroupsView.vue?vue&type=style&index=0&id=6f86f44a&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f86f44a"]])

export default __exports__